import { render, staticRenderFns } from "./StudentQuizTestHomeView.vue?vue&type=template&id=32c6c6d9"
import script from "./StudentQuizTestHomeView.vue?vue&type=script&lang=js"
export * from "./StudentQuizTestHomeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports